module.exports = __webpack_public_path__ + "img/plats.49a7e8da.svg";